import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
// Types
import { GetTicketEventAffiliates_getStreamAffiliateLinks_entities } from 'api/ticketing/types/GetTicketEventAffiliates';
import { StreamAffiliateLinkStatus } from 'api/graphql-global-types';
// Helpers
import { getPersonName } from 'pages/Events/helpers';
import { getAffiliateLinkUrl } from 'pages/Events/links';
// UI
import { errorNotification, successNotification } from 'ui/Notification';

type AffiliateRow = GetTicketEventAffiliates_getStreamAffiliateLinks_entities;
type AffiliateLink = AffiliateRow['link'];

type AffiliateRowActionsProps = {
  row: AffiliateRow;
  onEditRate: (row: AffiliateRow) => void;
  onRegenerate: (link: AffiliateLink) => void;
  onToggleStatus: (link: AffiliateLink) => void;
};

const AffiliateRowActions = ({
  row,
  onEditRate,
  onRegenerate,
  onToggleStatus,
}: AffiliateRowActionsProps): JSX.Element => {
  const active = row.link.status === StreamAffiliateLinkStatus.Active;

  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(getAffiliateLinkUrl(row.link.code));
      successNotification('Affiliate link copied');
    } catch {
      errorNotification('Could not copy the link');
    }
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      overlay={
        <Menu selectable={false}>
          <Menu.Item key="copy" onClick={handleCopy}>
            Copy affiliate link
          </Menu.Item>
          <Menu.Item key="rate" onClick={() => onEditRate(row)}>
            Edit commission rate
          </Menu.Item>
          <Menu.Item key="regenerate" onClick={() => onRegenerate(row.link)}>
            Generate new link
          </Menu.Item>
          <Menu.Item
            key="status"
            danger={active}
            onClick={() => onToggleStatus(row.link)}
          >
            {active ? 'Disable link' : 'Re-enable link'}
          </Menu.Item>
        </Menu>
      }
    >
      <Button
        size="small"
        aria-label={`Actions for ${getPersonName(row.link.user)}`}
        icon={<MoreOutlined />}
      />
    </Dropdown>
  );
};

export default AffiliateRowActions;
